webpackJsonp([195351340454287],{

/***/ 45:
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.parse = parse;
	exports.stringify = stringify;
	
	var trim = __webpack_require__(142);
	
	var C_COMMA = ',';
	var C_SPACE = ' ';
	var EMPTY = '';
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = [];
	  var input = String(value || EMPTY);
	  var index = input.indexOf(C_COMMA);
	  var lastIndex = 0;
	  var end = false;
	  var val;
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length;
	      end = true;
	    }
	
	    val = trim(input.slice(lastIndex, index));
	
	    if (val || !end) {
	      values.push(val);
	    }
	
	    lastIndex = index + 1;
	    index = input.indexOf(C_COMMA, lastIndex);
	  }
	
	  return values;
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {};
	  var left = settings.padLeft;
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === EMPTY) {
	    values = values.concat(EMPTY);
	  }
	
	  return trim(values.join(
	    (settings.padRight ? C_SPACE : EMPTY) +
	    C_COMMA +
	    (left || left === undefined || left === null ? C_SPACE : EMPTY)
	  ));
	}


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(583);
	var foreach = __webpack_require__(378);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(379);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(21);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(28);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(27);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(62);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(61);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(380);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(142);
	var paramCase = __webpack_require__(468);
	var information = __webpack_require__(588);
	var spaces = __webpack_require__(614);
	var commas = __webpack_require__(277);
	var nan = __webpack_require__(432);
	var is = __webpack_require__(620);
	
	module.exports = wrapper;
	
	function wrapper(h, node, prefix) {
	  var r;
	  var v;
	
	  if (typeof h !== 'function') {
	    throw new Error('h is not a function');
	  }
	
	  r = react(h);
	  v = vdom(h);
	
	  if (prefix === null || prefix === undefined) {
	    prefix = r === true || v === true ? 'h-' : false;
	  }
	
	  if (is('root', node)) {
	    if (node.children.length === 1 && is('element', node.children[0])) {
	      node = node.children[0];
	    } else {
	      node = {
	        type: 'element',
	        tagName: 'div',
	        properties: {},
	        children: node.children
	      };
	    }
	  } else if (!is('element', node)) {
	    throw new Error('Expected root or element, not `' + ((node && node.type) || node) + '`');
	  }
	
	  return toH(h, node, {
	    prefix: prefix,
	    key: 0,
	    react: r,
	    vdom: v,
	    hyperscript: hyperscript(h)
	  });
	}
	
	/* Transform a HAST node through a hyperscript interface
	 * to *anything*! */
	function toH(h, node, ctx) {
	  var selector = node.tagName;
	  var properties;
	  var attributes;
	  var children;
	  var property;
	  var elements;
	  var length;
	  var index;
	  var value;
	
	  properties = node.properties;
	  attributes = {};
	
	  for (property in properties) {
	    addAttribute(attributes, property, properties[property], ctx);
	  }
	
	  if (ctx.vdom === true) {
	    selector = selector.toUpperCase();
	  }
	
	  if (ctx.hyperscript === true && attributes.id) {
	    selector += '#' + attributes.id;
	    delete attributes.id;
	  }
	
	  if ((ctx.hyperscript === true || ctx.vdom === true) && attributes.className) {
	    selector += '.' + spaces.parse(attributes.className).join('.');
	    delete attributes.className;
	  }
	
	  if (typeof attributes.style === 'string') {
	    /* VDOM expects a `string` style in `attributes`
	     * See https://github.com/Matt-Esch/virtual-dom/blob/947ecf9/
	     * docs/vnode.md#propertiesstyle-vs-propertiesattributesstyle */
	    if (ctx.vdom === true) {
	      if (!attributes.attributes) {
	        attributes.attributes = {};
	      }
	
	      attributes.attributes.style = attributes.style;
	      delete attributes.style;
	    /* React only accepts `style` as object. */
	    } else if (ctx.react === true) {
	      attributes.style = parseStyle(attributes.style);
	    }
	  }
	
	  if (ctx.prefix) {
	    ctx.key++;
	    attributes.key = ctx.prefix + ctx.key;
	  }
	
	  elements = [];
	  children = node.children || [];
	  length = children.length;
	  index = -1;
	
	  while (++index < length) {
	    value = children[index];
	
	    if (is('element', value)) {
	      elements.push(toH(h, value, ctx));
	    } else if (is('text', value)) {
	      elements.push(value.value);
	    }
	  }
	
	  /* Ensure no React warnings are triggered for
	   * void elements having children passed in. */
	  return elements.length === 0 ? h(selector, attributes) : h(selector, attributes, elements);
	}
	
	/* Add `name` and its `value` to `props`. */
	function addAttribute(props, name, value, ctx) {
	  var info = information(name) || {};
	  var subprop;
	
	  /* Ignore nully, `false`, `NaN`, and falsey known
	   * booleans. */
	  if (
	    value === null ||
	    value === undefined ||
	    value === false ||
	    nan(value) ||
	    (info.boolean && !value)
	  ) {
	    return;
	  }
	
	  if (info.name) {
	    name = info.name;
	  } else if (ctx.react && !paramCasedReactProp(name)) {
	    name = camelCase(name);
	  } else {
	    name = paramCase(name);
	  }
	
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    /* Accept `array`.  Most props are space-separater. */
	    value = (info.commaSeparated ? commas : spaces).stringify(value);
	  }
	
	  /* Treat `true` and truthy known booleans. */
	  if (info.boolean && ctx.hyperscript === true) {
	    value = '';
	  }
	
	  if (info.name !== 'class' && (info.mustUseAttribute || !info.name)) {
	    if (ctx.vdom === true) {
	      subprop = 'attributes';
	    } else if (ctx.hyperscript === true) {
	      subprop = 'attrs';
	    }
	
	    if (subprop) {
	      if (props[subprop] === undefined) {
	        props[subprop] = {};
	      }
	
	      props[subprop][name] = value;
	
	      return;
	    }
	  }
	
	  props[info.propertyName || name] = value;
	}
	
	/* Check if `h` is `react.createElement`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function react(h) {
	  var node = h && h('div');
	  return Boolean(node && ('_owner' in node || '_store' in node) && node.key === null);
	}
	
	/* Check if `h` is `hyperscript`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function hyperscript(h) {
	  return Boolean(h && h.context && h.cleanup);
	}
	
	/**
	 * Check if `h` is `virtual-dom/h`.  It’s the only
	 * hyperscript “compatible” interface needing `attributes`. */
	function vdom(h) {
	  try {
	    return h('div').type === 'VirtualNode';
	  } catch (err) { /* Empty */ }
	
	  /* istanbul ignore next */
	  return false;
	}
	
	function parseStyle(value) {
	  var result = {};
	  var declarations = value.split(';');
	  var length = declarations.length;
	  var index = -1;
	  var declaration;
	  var prop;
	  var pos;
	
	  while (++index < length) {
	    declaration = declarations[index];
	    pos = declaration.indexOf(':');
	    if (pos !== -1) {
	      prop = camelCase(trim(declaration.slice(0, pos)));
	      result[prop] = trim(declaration.slice(pos + 1));
	    }
	  }
	
	  return result;
	}
	
	function paramCasedReactProp(name) {
	  var head = name.slice(0, 4);
	  return (head === 'data' || head === 'aria') && name.length > 4;
	}
	
	function camelCase(val) {
	  if (val.slice(0, 4) === '-ms-') {
	    val = 'ms-' + val.slice(4);
	  }
	
	  return val.replace(/-([a-z])/g, replace);
	}
	
	function replace($0, $1) {
	  return $1.toUpperCase();
	}


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	'use strict';
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function isNaN(value) {
		return value !== value;
	};


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(179);
	
	var implementation = __webpack_require__(185);
	var getPolyfill = __webpack_require__(186);
	var shim = __webpack_require__(433);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	define(implementation, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = implementation;


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(185);
	
	module.exports = function getPolyfill() {
		if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
			return Number.isNaN;
		}
		return implementation;
	};


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(179);
	var getPolyfill = __webpack_require__(186);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function shimNumberIsNaN() {
		var polyfill = getPolyfill();
		define(Number, { isNaN: polyfill }, { isNaN: function () { return Number.isNaN !== polyfill; } });
		return polyfill;
	};


/***/ }),

/***/ 468:
/***/ (function(module, exports) {

	'use strict';
	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	
	module.exports = exports = function kebabCase(str) {
		return str.replace(KEBAB_REGEX, function (match) {
			return '-' + match.toLowerCase();
		});
	};
	
	exports.reverse = function (str) {
		return str.replace(REVERSE_REGEX, function (match) {
			return match.slice(1).toUpperCase();
		});
	};


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(584);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ 584:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ 588:
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = getPropertyInformation;
	
	/* Constants. */
	var USE_ATTRIBUTE = 0x1;
	var USE_PROPERTY = 0x2;
	var BOOLEAN_VALUE = 0x8;
	var NUMERIC_VALUE = 0x10;
	var POSITIVE_NUMERIC_VALUE = 0x20 | 0x10;
	var OVERLOADED_BOOLEAN_VALUE = 0x40;
	var SPACE_SEPARATED = 0x80;
	var COMMA_SEPARATED = 0x100;
	
	/* Map of properties. Names are camel-cased properties. */
	var propertyConfig = {
	  /* Standard Properties. */
	  abbr: null,
	  accept: COMMA_SEPARATED,
	  acceptCharset: SPACE_SEPARATED,
	  accessKey: SPACE_SEPARATED,
	  action: null,
	  allowFullScreen: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  allowTransparency: USE_ATTRIBUTE,
	  alt: null,
	  /* https://html.spec.whatwg.org/#attr-link-as */
	  as: null,
	  async: BOOLEAN_VALUE,
	  autoComplete: SPACE_SEPARATED,
	  autoFocus: BOOLEAN_VALUE,
	  autoPlay: BOOLEAN_VALUE,
	  capture: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  cellPadding: null,
	  cellSpacing: null,
	  challenge: USE_ATTRIBUTE,
	  charSet: USE_ATTRIBUTE,
	  checked: USE_PROPERTY | BOOLEAN_VALUE,
	  cite: null,
	  /* To set className on SVG elements, it's necessary to
	   * use .setAttribute; this works on HTML elements too
	   * in all browsers except IE8. */
	  className: USE_ATTRIBUTE | SPACE_SEPARATED,
	  cols: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  colSpan: null,
	  command: null,
	  content: null,
	  contentEditable: null,
	  contextMenu: USE_ATTRIBUTE,
	  controls: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://github.com/WICG/controls-list/blob/gh-pages/explainer.md */
	  controlsList: SPACE_SEPARATED,
	  coords: NUMERIC_VALUE | COMMA_SEPARATED,
	  crossOrigin: null,
	  /* For `<object />` acts as `src`. */
	  data: null,
	  dateTime: USE_ATTRIBUTE,
	  default: BOOLEAN_VALUE,
	  defer: BOOLEAN_VALUE,
	  dir: null,
	  dirName: null,
	  disabled: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  download: OVERLOADED_BOOLEAN_VALUE,
	  draggable: null,
	  dropzone: SPACE_SEPARATED,
	  encType: null,
	  form: USE_ATTRIBUTE,
	  formAction: USE_ATTRIBUTE,
	  formEncType: USE_ATTRIBUTE,
	  formMethod: USE_ATTRIBUTE,
	  formNoValidate: BOOLEAN_VALUE,
	  formTarget: USE_ATTRIBUTE,
	  frameBorder: USE_ATTRIBUTE,
	  headers: SPACE_SEPARATED,
	  height: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  hidden: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  high: NUMERIC_VALUE,
	  href: null,
	  hrefLang: null,
	  htmlFor: SPACE_SEPARATED,
	  httpEquiv: SPACE_SEPARATED,
	  id: USE_PROPERTY,
	  inputMode: USE_ATTRIBUTE,
	  /* Web Components */
	  is: USE_ATTRIBUTE,
	  isMap: BOOLEAN_VALUE,
	  keyParams: USE_ATTRIBUTE,
	  keyType: USE_ATTRIBUTE,
	  kind: null,
	  label: null,
	  lang: null,
	  list: USE_ATTRIBUTE,
	  loop: USE_PROPERTY | BOOLEAN_VALUE,
	  low: NUMERIC_VALUE,
	  manifest: USE_ATTRIBUTE,
	  marginHeight: NUMERIC_VALUE,
	  marginWidth: NUMERIC_VALUE,
	  max: null,
	  maxLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  media: USE_ATTRIBUTE,
	  mediaGroup: null,
	  menu: null,
	  method: null,
	  min: null,
	  minLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  multiple: USE_PROPERTY | BOOLEAN_VALUE,
	  muted: USE_PROPERTY | BOOLEAN_VALUE,
	  name: null,
	  nonce: null,
	  noValidate: BOOLEAN_VALUE,
	  open: BOOLEAN_VALUE,
	  optimum: NUMERIC_VALUE,
	  pattern: null,
	  ping: SPACE_SEPARATED,
	  placeholder: null,
	  /* https://html.spec.whatwg.org/#attr-video-playsinline */
	  playsInline: BOOLEAN_VALUE,
	  poster: null,
	  preload: null,
	  /* https://html.spec.whatwg.org/#dom-head-profile */
	  profile: null,
	  radioGroup: null,
	  readOnly: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://html.spec.whatwg.org/#attr-link-referrerpolicy */
	  referrerPolicy: null,
	  /* `rel` is `relList` in DOM */
	  rel: SPACE_SEPARATED | USE_ATTRIBUTE,
	  required: BOOLEAN_VALUE,
	  reversed: BOOLEAN_VALUE,
	  role: USE_ATTRIBUTE,
	  rows: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  rowSpan: POSITIVE_NUMERIC_VALUE,
	  sandbox: SPACE_SEPARATED,
	  scope: null,
	  scoped: BOOLEAN_VALUE,
	  scrolling: null,
	  seamless: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  selected: USE_PROPERTY | BOOLEAN_VALUE,
	  shape: null,
	  size: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  sizes: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* https://html.spec.whatwg.org/#attr-slot */
	  slot: null,
	  sortable: BOOLEAN_VALUE,
	  sorted: SPACE_SEPARATED,
	  span: POSITIVE_NUMERIC_VALUE,
	  spellCheck: null,
	  src: null,
	  srcDoc: USE_PROPERTY,
	  srcLang: null,
	  srcSet: USE_ATTRIBUTE | COMMA_SEPARATED,
	  start: NUMERIC_VALUE,
	  step: null,
	  style: null,
	  summary: null,
	  tabIndex: NUMERIC_VALUE,
	  target: null,
	  title: null,
	  translate: null,
	  type: null,
	  typeMustMatch: BOOLEAN_VALUE,
	  useMap: null,
	  value: USE_PROPERTY,
	  volume: POSITIVE_NUMERIC_VALUE,
	  width: USE_ATTRIBUTE | NUMERIC_VALUE,
	  wmode: USE_ATTRIBUTE,
	  wrap: null,
	
	  /* Non-standard Properties. */
	
	  /* `autoCapitalize` and `autoCorrect` are supported in
	   * Mobile Safari for keyboard hints. */
	  autoCapitalize: null,
	  autoCorrect: null,
	  /* `autoSave` allows WebKit/Blink to persist values of
	   * input fields on page reloads */
	  autoSave: null,
	  /* `itemProp`, `itemScope`, `itemType` are for Microdata
	   * support. See http://schema.org/docs/gs.html */
	  itemProp: USE_ATTRIBUTE | SPACE_SEPARATED,
	  itemScope: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  itemType: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `itemID` and `itemRef` are for Microdata support as well
	   * but only specified in the the WHATWG spec document.
	   * See https://html.spec.whatwg.org/multipage/
	   * microdata.html#microdata-dom-api */
	  itemID: USE_ATTRIBUTE,
	  itemRef: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `property` is supported for OpenGraph in meta tags. */
	  property: null,
	  /* `results` show looking glass icon and recent searches
	   * on input search fields in WebKit/Blink */
	  results: null,
	  /* IE-only attribute that specifies security
	   * restrictions on an iframe as an alternative to the
	   * sandbox attribute on IE < 10 */
	  security: USE_ATTRIBUTE,
	  /* IE-only attribute that controls focus behavior */
	  unselectable: USE_ATTRIBUTE,
	
	  /* Ancient. */
	  xmlLang: USE_ATTRIBUTE,
	  xmlBase: USE_ATTRIBUTE
	};
	
	/* Map of properties to attributes.
	 * Names are lower-case properties.
	 * Values are HTML attributes. */
	var propertyToAttributeMapping = {
	  xmlbase: 'xml:base',
	  xmllang: 'xml:lang',
	  classname: 'class',
	  htmlfor: 'for',
	  httpequiv: 'http-equiv',
	  acceptcharset: 'accept-charset'
	};
	
	/* Expand config. */
	var information = {};
	var property;
	var name;
	var config;
	
	getPropertyInformation.all = information;
	
	for (property in propertyConfig) {
	  name = lower(property);
	  name = propertyToAttributeMapping[name] || name;
	  config = propertyConfig[property];
	
	  information[name] = {
	    name: name,
	    propertyName: property,
	    mustUseAttribute: check(config, USE_ATTRIBUTE),
	    mustUseProperty: check(config, USE_PROPERTY),
	    boolean: check(config, BOOLEAN_VALUE),
	    overloadedBoolean: check(config, OVERLOADED_BOOLEAN_VALUE),
	    numeric: check(config, NUMERIC_VALUE),
	    positiveNumeric: check(config, POSITIVE_NUMERIC_VALUE),
	    commaSeparated: check(config, COMMA_SEPARATED),
	    spaceSeparated: check(config, SPACE_SEPARATED)
	  };
	}
	
	/* Get a config for a property. */
	function getPropertyInformation(propertyName) {
	  var insensitive = lower(propertyName);
	
	  return information[propertyToAttributeMapping[insensitive] || insensitive];
	}
	
	/* Check a mask. */
	function check(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/* Lower-case a string. */
	function lower(value) {
	  return value.toLowerCase();
	}


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(56);


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(58);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(57);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(116);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(117);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(73);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(50);
	
	var _PropTypes = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(45);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(5);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var has = __webpack_require__(429);
	var toH = __webpack_require__(430);
	
	/* Expose `rehype-react`. */
	module.exports = rehype2react;
	
	/**
	 * Attach a react compiler.
	 *
	 * @param {Unified} processor - Instance.
	 * @param {Object?} [options]
	 * @param {Object?} [options.components]
	 *   - Components.
	 * @param {string?} [options.prefix]
	 *   - Key prefix.
	 * @param {Function?} [options.createElement]
	 *   - `h()`.
	 */
	function rehype2react(options) {
	  var settings = options || {};
	  var createElement = settings.createElement;
	  var components = settings.components || {};
	
	  this.Compiler = compiler;
	
	  /* Compile HAST to React. */
	  function compiler(node) {
	    if (node.type === 'root') {
	      if (node.children.length === 1 && node.children[0].type === 'element') {
	        node = node.children[0];
	      } else {
	        node = {
	          type: 'element',
	          tagName: 'div',
	          properties: {},
	          children: node.children
	        };
	      }
	    }
	
	    return toH(h, node, settings.prefix);
	  }
	
	  /* Wrap `createElement` to pass components in. */
	  function h(name, props, children) {
	    var component = has(components, name) ? components[name] : name;
	    return createElement(component, props, children);
	  }
	}


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(142);
	
	exports.parse = parse;
	exports.stringify = stringify;
	
	var empty = '';
	var space = ' ';
	var whiteSpace = /[ \t\n\r\f]+/g;
	
	function parse(value) {
	  var input = trim(String(value || empty));
	
	  if (input === empty) {
	    return [];
	  }
	
	  return input.split(whiteSpace);
	}
	
	function stringify(values) {
	  return trim(values.join(space));
	}


/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),

/***/ 620:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is;
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined;
	  var hasIndex = index !== null && index !== undefined;
	  var check = convert(test);
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node');
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node');
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false;
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index');
	  }
	
	  return Boolean(check.call(context, node, index, parent));
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test);
	  }
	
	  if (test === null || test === undefined) {
	    return ok;
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test);
	  }
	
	  if (typeof test === 'function') {
	    return test;
	  }
	
	  throw new Error('Expected function, string, or object as test');
	}
	
	function convertAll(tests) {
	  var results = [];
	  var length = tests.length;
	  var index = -1;
	
	  while (++index < length) {
	    results[index] = convert(tests[index]);
	  }
	
	  return results;
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches;
	
	  function matches(node) {
	    var key;
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests);
	  var length = checks.length;
	
	  return matches;
	
	  function matches() {
	    var index = -1;
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type;
	
	  function type(node) {
	    return Boolean(node && node.type === test);
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true;
	}


/***/ }),

/***/ 356:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"feature":"src-components-Feature----feature-module---feature---7uPQP","icon":"src-components-Feature----feature-module---icon---1Bljw","wiggle":"src-components-Feature----feature-module---wiggle---3M1qP","balloon":"src-components-Feature----feature-module---balloon---3lIpa","title":"src-components-Feature----feature-module---title---3Ie78","content":"src-components-Feature----feature-module---content---3ObVm"};

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _featureModule = __webpack_require__(356);
	
	var _featureModule2 = _interopRequireDefault(_featureModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Feature = function Feature(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _featureModule2.default.feature },
	    _react2.default.createElement(
	      'div',
	      { className: _featureModule2.default.icon, style: { animationDelay: Math.random() * 5000 + 'ms' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactFontawesome2.default, { icon: [props.iconprefix || 'fal', props.icon] }),
	        _react2.default.createElement('img', { className: _featureModule2.default.balloon, src: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==', alt: '' })
	      )
	    ),
	    _react2.default.createElement(
	      'h4',
	      { className: _featureModule2.default.title },
	      props.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _featureModule2.default.content },
	      props.children
	    )
	  );
	};
	
	exports.default = Feature;
	module.exports = exports['default'];

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-HeaderImage----header-module---wrapper---tDvNB","container-fluid":"src-components-HeaderImage----header-module---container-fluid---32F5u","row":"src-components-HeaderImage----header-module---row---3tvRD","reverse":"src-components-HeaderImage----header-module---reverse---3-hDz","col":"src-components-HeaderImage----header-module---col---1xM3y","col-xs":"src-components-HeaderImage----header-module---col-xs---26Zkf","col-xs-1":"src-components-HeaderImage----header-module---col-xs-1---3kCDz","col-xs-2":"src-components-HeaderImage----header-module---col-xs-2---2lNsr","col-xs-3":"src-components-HeaderImage----header-module---col-xs-3---1v2Oj","col-xs-4":"src-components-HeaderImage----header-module---col-xs-4---3-H5N","col-xs-5":"src-components-HeaderImage----header-module---col-xs-5---16zL3","col-xs-6":"src-components-HeaderImage----header-module---col-xs-6---U1P69","col-xs-7":"src-components-HeaderImage----header-module---col-xs-7---NJdEU","col-xs-8":"src-components-HeaderImage----header-module---col-xs-8---2Psvn","col-xs-9":"src-components-HeaderImage----header-module---col-xs-9---22Dcd","col-xs-10":"src-components-HeaderImage----header-module---col-xs-10---2h9ma","col-xs-11":"src-components-HeaderImage----header-module---col-xs-11---2YWWv","col-xs-12":"src-components-HeaderImage----header-module---col-xs-12---hMAwa","col-xs-offset-1":"src-components-HeaderImage----header-module---col-xs-offset-1---vK8w3","col-xs-offset-2":"src-components-HeaderImage----header-module---col-xs-offset-2---VZr6-","col-xs-offset-3":"src-components-HeaderImage----header-module---col-xs-offset-3---3BI5S","col-xs-offset-4":"src-components-HeaderImage----header-module---col-xs-offset-4---1mfwI","col-xs-offset-5":"src-components-HeaderImage----header-module---col-xs-offset-5---4NR9T","col-xs-offset-6":"src-components-HeaderImage----header-module---col-xs-offset-6---2Luud","col-xs-offset-7":"src-components-HeaderImage----header-module---col-xs-offset-7---1SP0N","col-xs-offset-8":"src-components-HeaderImage----header-module---col-xs-offset-8---1sW_A","col-xs-offset-9":"src-components-HeaderImage----header-module---col-xs-offset-9---AGozY","col-xs-offset-10":"src-components-HeaderImage----header-module---col-xs-offset-10---3kU_3","col-xs-offset-11":"src-components-HeaderImage----header-module---col-xs-offset-11---2YBPC","col-xs-offset-12":"src-components-HeaderImage----header-module---col-xs-offset-12---39n61","start-xs":"src-components-HeaderImage----header-module---start-xs---1GkAw","center-xs":"src-components-HeaderImage----header-module---center-xs---cnr27","end-xs":"src-components-HeaderImage----header-module---end-xs---2HHXP","top-xs":"src-components-HeaderImage----header-module---top-xs---2lqBw","middle-xs":"src-components-HeaderImage----header-module---middle-xs---3opLj","bottom-xs":"src-components-HeaderImage----header-module---bottom-xs---byBRd","around-xs":"src-components-HeaderImage----header-module---around-xs---Homp8","between-xs":"src-components-HeaderImage----header-module---between-xs---2l5iu","first-xs":"src-components-HeaderImage----header-module---first-xs---19BGB","last-xs":"src-components-HeaderImage----header-module---last-xs---11ws_","hero":"src-components-HeaderImage----header-module---hero---1aGuF","heroPadded":"src-components-HeaderImage----header-module---heroPadded---1zu8v","bigWrapper":"src-components-HeaderImage----header-module---bigWrapper---2E2WH"};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(25);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _headerModule = __webpack_require__(359);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderImage = function HeaderImage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.edge2edge ? _headerModule2.default.hero : _headerModule2.default.heroPadded },
	    _react2.default.createElement(_gatsbyImage2.default, {
	      alt: props.description,
	      sizes: props.sizes
	    })
	  );
	};
	
	exports.default = HeaderImage;
	module.exports = exports['default'];

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"figure":"src-components-Image----image-module---figure---SOd_5","caption":"src-components-Image----image-module---caption---6C21O","imageButton":"src-components-Image----image-module---imageButton---3mzVX","zoomIcon":"src-components-Image----image-module---zoomIcon---12CBo"};

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(25);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _imageModule = __webpack_require__(360);
	
	var _imageModule2 = _interopRequireDefault(_imageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Because I'm shoe-horning HTML into my markdown content, I need
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * extra magic to have them responsive and render properly
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Image = function (_React$PureComponent) {
	  _inherits(Image, _React$PureComponent);
	
	  function Image() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Image);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.zoom = function () {
	      _this.props.onZoom(_this.state.image);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Image.prototype.componentWillMount = function componentWillMount(props) {
	    for (var i = 0; i < this.props.images.length; i++) {
	      if (this.props.images[i].title === this.props.title) {
	        this.setState({ image: this.props.images[i] });
	        break;
	      }
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var hideCaption = this.props.nocaption !== undefined && this.props.nocaption !== "true";
	
	    var image = _react2.default.createElement(
	      'figure',
	      { className: _imageModule2.default.figure },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: this.state.image.sizes,
	        alt: this.state.image.description
	      }),
	      !hideCaption && _react2.default.createElement(
	        'figcaption',
	        { className: _imageModule2.default.caption },
	        this.state.image.description
	      )
	    );
	
	    if (this.props.zoom !== undefined) {
	      return _react2.default.createElement(
	        'button',
	        { className: _imageModule2.default.imageButton, onClick: this.zoom },
	        _react2.default.createElement(
	          'span',
	          { className: _imageModule2.default.zoomIcon + ' fa-layers fa-fw' },
	          _react2.default.createElement(_reactFontawesome2.default, { size: '2x', transform: 'grow-2', icon: 'circle', color: 'white' }),
	          _react2.default.createElement(_reactFontawesome2.default, { size: '2x', transform: 'shrink-4 right-1 down-1', icon: ['fas', 'search-plus'], mask: 'circle' })
	        ),
	        image
	      );
	    }
	
	    return image;
	  };
	
	  return Image;
	}(_react2.default.PureComponent);
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-KeyFeatures----features-module---wrapper---17-bJ","container-fluid":"src-components-KeyFeatures----features-module---container-fluid---WIx5I","row":"src-components-KeyFeatures----features-module---row---ULvyT","reverse":"src-components-KeyFeatures----features-module---reverse---3uwfd","col":"src-components-KeyFeatures----features-module---col---1q9MR","col-xs":"src-components-KeyFeatures----features-module---col-xs---1W0B5","col-xs-1":"src-components-KeyFeatures----features-module---col-xs-1---1rDmd","col-xs-2":"src-components-KeyFeatures----features-module---col-xs-2---1P5O9","col-xs-3":"src-components-KeyFeatures----features-module---col-xs-3---rtrcg","col-xs-4":"src-components-KeyFeatures----features-module---col-xs-4---2_I28","col-xs-5":"src-components-KeyFeatures----features-module---col-xs-5---39HUU","col-xs-6":"src-components-KeyFeatures----features-module---col-xs-6---2cmSZ","col-xs-7":"src-components-KeyFeatures----features-module---col-xs-7---3eiuM","col-xs-8":"src-components-KeyFeatures----features-module---col-xs-8---gWjd_","col-xs-9":"src-components-KeyFeatures----features-module---col-xs-9---aAE4e","col-xs-10":"src-components-KeyFeatures----features-module---col-xs-10---3t_So","col-xs-11":"src-components-KeyFeatures----features-module---col-xs-11---evabL","col-xs-12":"src-components-KeyFeatures----features-module---col-xs-12---2cHc7","col-xs-offset-1":"src-components-KeyFeatures----features-module---col-xs-offset-1---3qxb1","col-xs-offset-2":"src-components-KeyFeatures----features-module---col-xs-offset-2---1Ek2f","col-xs-offset-3":"src-components-KeyFeatures----features-module---col-xs-offset-3---2Y_S_","col-xs-offset-4":"src-components-KeyFeatures----features-module---col-xs-offset-4---1jahj","col-xs-offset-5":"src-components-KeyFeatures----features-module---col-xs-offset-5---3iL6l","col-xs-offset-6":"src-components-KeyFeatures----features-module---col-xs-offset-6---1qD6W","col-xs-offset-7":"src-components-KeyFeatures----features-module---col-xs-offset-7---HE7v5","col-xs-offset-8":"src-components-KeyFeatures----features-module---col-xs-offset-8---1kwP2","col-xs-offset-9":"src-components-KeyFeatures----features-module---col-xs-offset-9---2n_OZ","col-xs-offset-10":"src-components-KeyFeatures----features-module---col-xs-offset-10---7mkMM","col-xs-offset-11":"src-components-KeyFeatures----features-module---col-xs-offset-11---r8cts","col-xs-offset-12":"src-components-KeyFeatures----features-module---col-xs-offset-12---1fUrY","start-xs":"src-components-KeyFeatures----features-module---start-xs---2ixlW","center-xs":"src-components-KeyFeatures----features-module---center-xs---2fOe2","end-xs":"src-components-KeyFeatures----features-module---end-xs---1GKtO","top-xs":"src-components-KeyFeatures----features-module---top-xs---2UTUk","middle-xs":"src-components-KeyFeatures----features-module---middle-xs---3xO0g","bottom-xs":"src-components-KeyFeatures----features-module---bottom-xs---3_DPU","around-xs":"src-components-KeyFeatures----features-module---around-xs---371wo","between-xs":"src-components-KeyFeatures----features-module---between-xs---3Gz3b","first-xs":"src-components-KeyFeatures----features-module---first-xs---vIDrV","last-xs":"src-components-KeyFeatures----features-module---last-xs---22CaT","container":"src-components-KeyFeatures----features-module---container---1JeWE","col-sm":"src-components-KeyFeatures----features-module---col-sm---xrByS","col-sm-1":"src-components-KeyFeatures----features-module---col-sm-1---35Pqy","col-sm-2":"src-components-KeyFeatures----features-module---col-sm-2---1Y8S3","col-sm-3":"src-components-KeyFeatures----features-module---col-sm-3---1r5h3","col-sm-4":"src-components-KeyFeatures----features-module---col-sm-4---IEmBc","col-sm-5":"src-components-KeyFeatures----features-module---col-sm-5---2ALbP","col-sm-6":"src-components-KeyFeatures----features-module---col-sm-6---fX73C","col-sm-7":"src-components-KeyFeatures----features-module---col-sm-7---2NM8z","col-sm-8":"src-components-KeyFeatures----features-module---col-sm-8---2qgzf","col-sm-9":"src-components-KeyFeatures----features-module---col-sm-9---1LWmA","col-sm-10":"src-components-KeyFeatures----features-module---col-sm-10---2TtNQ","col-sm-11":"src-components-KeyFeatures----features-module---col-sm-11---IBshj","col-sm-12":"src-components-KeyFeatures----features-module---col-sm-12---d7IPS","col-sm-offset-1":"src-components-KeyFeatures----features-module---col-sm-offset-1---1Lu3j","col-sm-offset-2":"src-components-KeyFeatures----features-module---col-sm-offset-2---lyxuD","col-sm-offset-3":"src-components-KeyFeatures----features-module---col-sm-offset-3---2cH09","col-sm-offset-4":"src-components-KeyFeatures----features-module---col-sm-offset-4---23t2y","col-sm-offset-5":"src-components-KeyFeatures----features-module---col-sm-offset-5----T5iu","col-sm-offset-6":"src-components-KeyFeatures----features-module---col-sm-offset-6---T-64V","col-sm-offset-7":"src-components-KeyFeatures----features-module---col-sm-offset-7---R8sl9","col-sm-offset-8":"src-components-KeyFeatures----features-module---col-sm-offset-8---TmhAE","col-sm-offset-9":"src-components-KeyFeatures----features-module---col-sm-offset-9---2cOim","col-sm-offset-10":"src-components-KeyFeatures----features-module---col-sm-offset-10---2qy4K","col-sm-offset-11":"src-components-KeyFeatures----features-module---col-sm-offset-11---Ys40e","col-sm-offset-12":"src-components-KeyFeatures----features-module---col-sm-offset-12---2KFaD","start-sm":"src-components-KeyFeatures----features-module---start-sm---2E-dj","center-sm":"src-components-KeyFeatures----features-module---center-sm---2Fwir","end-sm":"src-components-KeyFeatures----features-module---end-sm---2NajR","top-sm":"src-components-KeyFeatures----features-module---top-sm---1HMfF","middle-sm":"src-components-KeyFeatures----features-module---middle-sm---y4peC","bottom-sm":"src-components-KeyFeatures----features-module---bottom-sm---3SYqf","around-sm":"src-components-KeyFeatures----features-module---around-sm---i1fZz","between-sm":"src-components-KeyFeatures----features-module---between-sm---eKu60","first-sm":"src-components-KeyFeatures----features-module---first-sm---1QHCC","last-sm":"src-components-KeyFeatures----features-module---last-sm---hMUIR","col-md":"src-components-KeyFeatures----features-module---col-md---3vGE2","col-md-1":"src-components-KeyFeatures----features-module---col-md-1---fn7Sy","col-md-2":"src-components-KeyFeatures----features-module---col-md-2---ARbO1","col-md-3":"src-components-KeyFeatures----features-module---col-md-3---2P4j4","col-md-4":"src-components-KeyFeatures----features-module---col-md-4---3ACOB","col-md-5":"src-components-KeyFeatures----features-module---col-md-5---2UV6H","col-md-6":"src-components-KeyFeatures----features-module---col-md-6---14Yhu","col-md-7":"src-components-KeyFeatures----features-module---col-md-7---2QxrM","col-md-8":"src-components-KeyFeatures----features-module---col-md-8---1iICK","col-md-9":"src-components-KeyFeatures----features-module---col-md-9---2AgFw","col-md-10":"src-components-KeyFeatures----features-module---col-md-10---3LHmM","col-md-11":"src-components-KeyFeatures----features-module---col-md-11---palPF","col-md-12":"src-components-KeyFeatures----features-module---col-md-12---1e0Wi","col-md-offset-1":"src-components-KeyFeatures----features-module---col-md-offset-1---1iSZl","col-md-offset-2":"src-components-KeyFeatures----features-module---col-md-offset-2---1dQe7","col-md-offset-3":"src-components-KeyFeatures----features-module---col-md-offset-3---13uMo","col-md-offset-4":"src-components-KeyFeatures----features-module---col-md-offset-4---WD2-R","col-md-offset-5":"src-components-KeyFeatures----features-module---col-md-offset-5---ZF0WS","col-md-offset-6":"src-components-KeyFeatures----features-module---col-md-offset-6---2EbqN","col-md-offset-7":"src-components-KeyFeatures----features-module---col-md-offset-7---2vhrb","col-md-offset-8":"src-components-KeyFeatures----features-module---col-md-offset-8---2ZOpg","col-md-offset-9":"src-components-KeyFeatures----features-module---col-md-offset-9---2099v","col-md-offset-10":"src-components-KeyFeatures----features-module---col-md-offset-10---svowj","col-md-offset-11":"src-components-KeyFeatures----features-module---col-md-offset-11---23pkK","col-md-offset-12":"src-components-KeyFeatures----features-module---col-md-offset-12---2uySR","start-md":"src-components-KeyFeatures----features-module---start-md---M1918","center-md":"src-components-KeyFeatures----features-module---center-md---36Cda","end-md":"src-components-KeyFeatures----features-module---end-md---3IntH","top-md":"src-components-KeyFeatures----features-module---top-md---1XGVg","middle-md":"src-components-KeyFeatures----features-module---middle-md---uFzlD","bottom-md":"src-components-KeyFeatures----features-module---bottom-md---5C2l8","around-md":"src-components-KeyFeatures----features-module---around-md---3uame","between-md":"src-components-KeyFeatures----features-module---between-md---1K0xZ","first-md":"src-components-KeyFeatures----features-module---first-md---3mYn_","last-md":"src-components-KeyFeatures----features-module---last-md---3vtd1","col-lg":"src-components-KeyFeatures----features-module---col-lg---t_JZz","col-lg-1":"src-components-KeyFeatures----features-module---col-lg-1---1xgpP","col-lg-2":"src-components-KeyFeatures----features-module---col-lg-2---3NAr3","col-lg-3":"src-components-KeyFeatures----features-module---col-lg-3---viBSi","col-lg-4":"src-components-KeyFeatures----features-module---col-lg-4---3X7zf","col-lg-5":"src-components-KeyFeatures----features-module---col-lg-5---21oc4","col-lg-6":"src-components-KeyFeatures----features-module---col-lg-6---1IvHv","col-lg-7":"src-components-KeyFeatures----features-module---col-lg-7---1L2m3","col-lg-8":"src-components-KeyFeatures----features-module---col-lg-8---PF1s9","col-lg-9":"src-components-KeyFeatures----features-module---col-lg-9---1JAwb","col-lg-10":"src-components-KeyFeatures----features-module---col-lg-10---2Bxu-","col-lg-11":"src-components-KeyFeatures----features-module---col-lg-11---2-QXK","col-lg-12":"src-components-KeyFeatures----features-module---col-lg-12---1QaXf","col-lg-offset-1":"src-components-KeyFeatures----features-module---col-lg-offset-1---tObvs","col-lg-offset-2":"src-components-KeyFeatures----features-module---col-lg-offset-2---31wBv","col-lg-offset-3":"src-components-KeyFeatures----features-module---col-lg-offset-3---3vapO","col-lg-offset-4":"src-components-KeyFeatures----features-module---col-lg-offset-4---1le_K","col-lg-offset-5":"src-components-KeyFeatures----features-module---col-lg-offset-5---ZATzR","col-lg-offset-6":"src-components-KeyFeatures----features-module---col-lg-offset-6---u0GDJ","col-lg-offset-7":"src-components-KeyFeatures----features-module---col-lg-offset-7---2-kga","col-lg-offset-8":"src-components-KeyFeatures----features-module---col-lg-offset-8---3jYDi","col-lg-offset-9":"src-components-KeyFeatures----features-module---col-lg-offset-9---21qN7","col-lg-offset-10":"src-components-KeyFeatures----features-module---col-lg-offset-10---2aaCq","col-lg-offset-11":"src-components-KeyFeatures----features-module---col-lg-offset-11---31CkV","col-lg-offset-12":"src-components-KeyFeatures----features-module---col-lg-offset-12---F4qwA","start-lg":"src-components-KeyFeatures----features-module---start-lg---3lcK2","center-lg":"src-components-KeyFeatures----features-module---center-lg---94QQi","end-lg":"src-components-KeyFeatures----features-module---end-lg---1UFDm","top-lg":"src-components-KeyFeatures----features-module---top-lg---1k76G","middle-lg":"src-components-KeyFeatures----features-module---middle-lg---1U7go","bottom-lg":"src-components-KeyFeatures----features-module---bottom-lg---WRCjI","around-lg":"src-components-KeyFeatures----features-module---around-lg---Pwv30","between-lg":"src-components-KeyFeatures----features-module---between-lg---8Jsp-","first-lg":"src-components-KeyFeatures----features-module---first-lg---URFUD","last-lg":"src-components-KeyFeatures----features-module---last-lg---3gH8E","features":"src-components-KeyFeatures----features-module---features---R5buZ"};

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _featuresModule = __webpack_require__(361);
	
	var _featuresModule2 = _interopRequireDefault(_featuresModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Features = function Features(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: _featuresModule2.default.features },
	    _react2.default.createElement(
	      'ul',
	      null,
	      children
	    )
	  );
	};
	
	exports.default = Features;
	module.exports = exports['default'];

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(25);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(43);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _lightboxModule = __webpack_require__(362);
	
	var _lightboxModule2 = _interopRequireDefault(_lightboxModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'span',
	    null,
	    props.image && _react2.default.createElement(
	      _reactAddonsCssTransitionGroup2.default,
	      {
	        transitionName: _lightboxModule2.default,
	        transitionAppear: true,
	        transitionAppearTimeout: 300,
	        transitionEnter: false,
	        transitionLeaveTimeout: 300
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _lightboxModule2.default.lightbox },
	        _react2.default.createElement(
	          'button',
	          { className: _lightboxModule2.default.closeButton, onClick: props.onClose },
	          _react2.default.createElement(
	            'span',
	            { className: _lightboxModule2.default.closeIcon + ' fa-layers fa-fw' },
	            _react2.default.createElement(_reactFontawesome2.default, { size: '2x', transform: 'grow-2', icon: 'circle', color: 'white' }),
	            _react2.default.createElement(_reactFontawesome2.default, { size: '2x', icon: ['fas', 'times'], transform: 'shrink-2 right-2' })
	          )
	        ),
	        _react2.default.createElement('img', {
	          className: _lightboxModule2.default.image,
	          sizes: props.image.sizes.sizes,
	          src: props.image.sizes.src,
	          srcSet: props.image.sizes.srcSet
	        })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-Lightbox----lightbox-module---wrapper---3_76H","container-fluid":"src-components-Lightbox----lightbox-module---container-fluid---1MN0w","row":"src-components-Lightbox----lightbox-module---row---3Kky3","reverse":"src-components-Lightbox----lightbox-module---reverse---3GLYM","col":"src-components-Lightbox----lightbox-module---col---n7Svf","col-xs":"src-components-Lightbox----lightbox-module---col-xs---3jZYR","col-xs-1":"src-components-Lightbox----lightbox-module---col-xs-1---J4Ddd","col-xs-2":"src-components-Lightbox----lightbox-module---col-xs-2---2kgGb","col-xs-3":"src-components-Lightbox----lightbox-module---col-xs-3---1ZRwk","col-xs-4":"src-components-Lightbox----lightbox-module---col-xs-4---1s28_","col-xs-5":"src-components-Lightbox----lightbox-module---col-xs-5---2P6ZX","col-xs-6":"src-components-Lightbox----lightbox-module---col-xs-6---eL-J8","col-xs-7":"src-components-Lightbox----lightbox-module---col-xs-7---2PcTX","col-xs-8":"src-components-Lightbox----lightbox-module---col-xs-8---uJp0r","col-xs-9":"src-components-Lightbox----lightbox-module---col-xs-9---noxFl","col-xs-10":"src-components-Lightbox----lightbox-module---col-xs-10---OuMta","col-xs-11":"src-components-Lightbox----lightbox-module---col-xs-11---26lOA","col-xs-12":"src-components-Lightbox----lightbox-module---col-xs-12---3_Vuj","col-xs-offset-1":"src-components-Lightbox----lightbox-module---col-xs-offset-1---2I8Nd","col-xs-offset-2":"src-components-Lightbox----lightbox-module---col-xs-offset-2---1QHiF","col-xs-offset-3":"src-components-Lightbox----lightbox-module---col-xs-offset-3---1iuJ4","col-xs-offset-4":"src-components-Lightbox----lightbox-module---col-xs-offset-4---3IKKp","col-xs-offset-5":"src-components-Lightbox----lightbox-module---col-xs-offset-5---2qkiM","col-xs-offset-6":"src-components-Lightbox----lightbox-module---col-xs-offset-6---zCtYG","col-xs-offset-7":"src-components-Lightbox----lightbox-module---col-xs-offset-7---3bfLa","col-xs-offset-8":"src-components-Lightbox----lightbox-module---col-xs-offset-8---3SjJM","col-xs-offset-9":"src-components-Lightbox----lightbox-module---col-xs-offset-9---1eLfp","col-xs-offset-10":"src-components-Lightbox----lightbox-module---col-xs-offset-10---20jds","col-xs-offset-11":"src-components-Lightbox----lightbox-module---col-xs-offset-11---1RMPF","col-xs-offset-12":"src-components-Lightbox----lightbox-module---col-xs-offset-12---23AP0","start-xs":"src-components-Lightbox----lightbox-module---start-xs---2MBor","center-xs":"src-components-Lightbox----lightbox-module---center-xs---3Itq5","end-xs":"src-components-Lightbox----lightbox-module---end-xs---17-Bz","top-xs":"src-components-Lightbox----lightbox-module---top-xs---bzryW","middle-xs":"src-components-Lightbox----lightbox-module---middle-xs---3ErOS","bottom-xs":"src-components-Lightbox----lightbox-module---bottom-xs---23B6B","around-xs":"src-components-Lightbox----lightbox-module---around-xs---2TVX8","between-xs":"src-components-Lightbox----lightbox-module---between-xs---L0TJg","first-xs":"src-components-Lightbox----lightbox-module---first-xs---yVJ0u","last-xs":"src-components-Lightbox----lightbox-module---last-xs---2a3rS","container":"src-components-Lightbox----lightbox-module---container---3IGdN","col-sm":"src-components-Lightbox----lightbox-module---col-sm---3An99","col-sm-1":"src-components-Lightbox----lightbox-module---col-sm-1---3OQzo","col-sm-2":"src-components-Lightbox----lightbox-module---col-sm-2---1ptXa","col-sm-3":"src-components-Lightbox----lightbox-module---col-sm-3---yqVvQ","col-sm-4":"src-components-Lightbox----lightbox-module---col-sm-4---2E7rg","col-sm-5":"src-components-Lightbox----lightbox-module---col-sm-5---3sHqh","col-sm-6":"src-components-Lightbox----lightbox-module---col-sm-6---WtkNc","col-sm-7":"src-components-Lightbox----lightbox-module---col-sm-7---23Y3s","col-sm-8":"src-components-Lightbox----lightbox-module---col-sm-8---23hsr","col-sm-9":"src-components-Lightbox----lightbox-module---col-sm-9---5QnZb","col-sm-10":"src-components-Lightbox----lightbox-module---col-sm-10---3Wjz4","col-sm-11":"src-components-Lightbox----lightbox-module---col-sm-11---3lcRW","col-sm-12":"src-components-Lightbox----lightbox-module---col-sm-12---2rQJh","col-sm-offset-1":"src-components-Lightbox----lightbox-module---col-sm-offset-1---zzCZO","col-sm-offset-2":"src-components-Lightbox----lightbox-module---col-sm-offset-2---3yvRe","col-sm-offset-3":"src-components-Lightbox----lightbox-module---col-sm-offset-3---La13Z","col-sm-offset-4":"src-components-Lightbox----lightbox-module---col-sm-offset-4---2ZIGo","col-sm-offset-5":"src-components-Lightbox----lightbox-module---col-sm-offset-5---ev53R","col-sm-offset-6":"src-components-Lightbox----lightbox-module---col-sm-offset-6---1USaT","col-sm-offset-7":"src-components-Lightbox----lightbox-module---col-sm-offset-7---3XWDI","col-sm-offset-8":"src-components-Lightbox----lightbox-module---col-sm-offset-8---2fQ-N","col-sm-offset-9":"src-components-Lightbox----lightbox-module---col-sm-offset-9---L7kx8","col-sm-offset-10":"src-components-Lightbox----lightbox-module---col-sm-offset-10---2g0eR","col-sm-offset-11":"src-components-Lightbox----lightbox-module---col-sm-offset-11---2Yydn","col-sm-offset-12":"src-components-Lightbox----lightbox-module---col-sm-offset-12---2xttg","start-sm":"src-components-Lightbox----lightbox-module---start-sm---2wo-h","center-sm":"src-components-Lightbox----lightbox-module---center-sm---1Fgbp","end-sm":"src-components-Lightbox----lightbox-module---end-sm---2-l2b","top-sm":"src-components-Lightbox----lightbox-module---top-sm---3ghai","middle-sm":"src-components-Lightbox----lightbox-module---middle-sm---2k5Dl","bottom-sm":"src-components-Lightbox----lightbox-module---bottom-sm---cah6r","around-sm":"src-components-Lightbox----lightbox-module---around-sm---yEAgA","between-sm":"src-components-Lightbox----lightbox-module---between-sm---2eJ2r","first-sm":"src-components-Lightbox----lightbox-module---first-sm---37hQY","last-sm":"src-components-Lightbox----lightbox-module---last-sm---3a2Ty","col-md":"src-components-Lightbox----lightbox-module---col-md---PwrS-","col-md-1":"src-components-Lightbox----lightbox-module---col-md-1---2ZTFm","col-md-2":"src-components-Lightbox----lightbox-module---col-md-2---3IyU-","col-md-3":"src-components-Lightbox----lightbox-module---col-md-3---2DUr4","col-md-4":"src-components-Lightbox----lightbox-module---col-md-4---3Om4l","col-md-5":"src-components-Lightbox----lightbox-module---col-md-5---1Jwz7","col-md-6":"src-components-Lightbox----lightbox-module---col-md-6---qCIzv","col-md-7":"src-components-Lightbox----lightbox-module---col-md-7---1cJQ5","col-md-8":"src-components-Lightbox----lightbox-module---col-md-8---1uQut","col-md-9":"src-components-Lightbox----lightbox-module---col-md-9---pTZFr","col-md-10":"src-components-Lightbox----lightbox-module---col-md-10---318Pq","col-md-11":"src-components-Lightbox----lightbox-module---col-md-11---yxjgd","col-md-12":"src-components-Lightbox----lightbox-module---col-md-12---1ADd4","col-md-offset-1":"src-components-Lightbox----lightbox-module---col-md-offset-1---10jfd","col-md-offset-2":"src-components-Lightbox----lightbox-module---col-md-offset-2---3Np7c","col-md-offset-3":"src-components-Lightbox----lightbox-module---col-md-offset-3---1BK1S","col-md-offset-4":"src-components-Lightbox----lightbox-module---col-md-offset-4---2n1iQ","col-md-offset-5":"src-components-Lightbox----lightbox-module---col-md-offset-5---XAaZk","col-md-offset-6":"src-components-Lightbox----lightbox-module---col-md-offset-6---39gt1","col-md-offset-7":"src-components-Lightbox----lightbox-module---col-md-offset-7---2ydVV","col-md-offset-8":"src-components-Lightbox----lightbox-module---col-md-offset-8---4TqeX","col-md-offset-9":"src-components-Lightbox----lightbox-module---col-md-offset-9---2_-8n","col-md-offset-10":"src-components-Lightbox----lightbox-module---col-md-offset-10---3Zhri","col-md-offset-11":"src-components-Lightbox----lightbox-module---col-md-offset-11---3B4WZ","col-md-offset-12":"src-components-Lightbox----lightbox-module---col-md-offset-12---1qgx-","start-md":"src-components-Lightbox----lightbox-module---start-md---2eqBT","center-md":"src-components-Lightbox----lightbox-module---center-md---2laRt","end-md":"src-components-Lightbox----lightbox-module---end-md---2KTSn","top-md":"src-components-Lightbox----lightbox-module---top-md---4KZ-Z","middle-md":"src-components-Lightbox----lightbox-module---middle-md---2Wgnd","bottom-md":"src-components-Lightbox----lightbox-module---bottom-md---sIIvR","around-md":"src-components-Lightbox----lightbox-module---around-md---16KLA","between-md":"src-components-Lightbox----lightbox-module---between-md---MmsPj","first-md":"src-components-Lightbox----lightbox-module---first-md---2F8I8","last-md":"src-components-Lightbox----lightbox-module---last-md---1ui_P","col-lg":"src-components-Lightbox----lightbox-module---col-lg---2sXb0","col-lg-1":"src-components-Lightbox----lightbox-module---col-lg-1---2zd8d","col-lg-2":"src-components-Lightbox----lightbox-module---col-lg-2---3E3kJ","col-lg-3":"src-components-Lightbox----lightbox-module---col-lg-3---2zweO","col-lg-4":"src-components-Lightbox----lightbox-module---col-lg-4---1rNfj","col-lg-5":"src-components-Lightbox----lightbox-module---col-lg-5---2pat5","col-lg-6":"src-components-Lightbox----lightbox-module---col-lg-6---1MSS8","col-lg-7":"src-components-Lightbox----lightbox-module---col-lg-7---33CG6","col-lg-8":"src-components-Lightbox----lightbox-module---col-lg-8---2uXUq","col-lg-9":"src-components-Lightbox----lightbox-module---col-lg-9---2tAQG","col-lg-10":"src-components-Lightbox----lightbox-module---col-lg-10---31Kwh","col-lg-11":"src-components-Lightbox----lightbox-module---col-lg-11---1RPui","col-lg-12":"src-components-Lightbox----lightbox-module---col-lg-12---1mLT-","col-lg-offset-1":"src-components-Lightbox----lightbox-module---col-lg-offset-1---3tDdg","col-lg-offset-2":"src-components-Lightbox----lightbox-module---col-lg-offset-2---1h8kN","col-lg-offset-3":"src-components-Lightbox----lightbox-module---col-lg-offset-3---21AMw","col-lg-offset-4":"src-components-Lightbox----lightbox-module---col-lg-offset-4---1g_h-","col-lg-offset-5":"src-components-Lightbox----lightbox-module---col-lg-offset-5---3VzYU","col-lg-offset-6":"src-components-Lightbox----lightbox-module---col-lg-offset-6---1TCxc","col-lg-offset-7":"src-components-Lightbox----lightbox-module---col-lg-offset-7---2npO-","col-lg-offset-8":"src-components-Lightbox----lightbox-module---col-lg-offset-8---Te_63","col-lg-offset-9":"src-components-Lightbox----lightbox-module---col-lg-offset-9---GwAZ2","col-lg-offset-10":"src-components-Lightbox----lightbox-module---col-lg-offset-10---3RUUa","col-lg-offset-11":"src-components-Lightbox----lightbox-module---col-lg-offset-11---1Taat","col-lg-offset-12":"src-components-Lightbox----lightbox-module---col-lg-offset-12---27fKC","start-lg":"src-components-Lightbox----lightbox-module---start-lg---1LFQz","center-lg":"src-components-Lightbox----lightbox-module---center-lg---SPXSK","end-lg":"src-components-Lightbox----lightbox-module---end-lg---2Ny23","top-lg":"src-components-Lightbox----lightbox-module---top-lg---16LYB","middle-lg":"src-components-Lightbox----lightbox-module---middle-lg---ZSgaJ","bottom-lg":"src-components-Lightbox----lightbox-module---bottom-lg---1ko9f","around-lg":"src-components-Lightbox----lightbox-module---around-lg---10eyl","between-lg":"src-components-Lightbox----lightbox-module---between-lg---1fuwT","first-lg":"src-components-Lightbox----lightbox-module---first-lg---3ryJf","last-lg":"src-components-Lightbox----lightbox-module---last-lg---3DpAf","lightbox":"src-components-Lightbox----lightbox-module---lightbox---3f5za","appear":"src-components-Lightbox----lightbox-module---appear---1gd0c","appearActive":"src-components-Lightbox----lightbox-module---appearActive---ZuARa","leave":"src-components-Lightbox----lightbox-module---leave---1TfNn","leaveActive":"src-components-Lightbox----lightbox-module---leaveActive---3kVdu","imageWrapper":"src-components-Lightbox----lightbox-module---imageWrapper---36dQv","image":"src-components-Lightbox----lightbox-module---image---3ZBbw","closeButton":"src-components-Lightbox----lightbox-module---closeButton---1dUh7"};

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _linkModule = __webpack_require__(363);
	
	var _linkModule2 = _interopRequireDefault(_linkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'a',
	    { className: _linkModule2.default.link, href: props.href },
	    props.icon && _react2.default.createElement(_reactFontawesome2.default, { icon: [props.iconprefix || 'fal', props.icon] }),
	    '\xA0',
	    props.label
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"src-components-Link----link-module---link---nQPDs"};

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _quoteModule = __webpack_require__(365);
	
	var _quoteModule2 = _interopRequireDefault(_quoteModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: _quoteModule2.default.quote },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'quote-left'], transform: 'up-6' })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      children
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'quote-right'], transform: 'down-6' })
	    )
	  );
	};
	
	exports.default = Quote;
	module.exports = exports['default'];

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"quote":"src-components-Quote----quote-module---quote---1oeoC"};

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _tagsModule = __webpack_require__(366);
	
	var _tagsModule2 = _interopRequireDefault(_tagsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _tagsModule2.default.tags },
	    props.tags.map(function (tag) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _tagsModule2.default.tag, to: '/tag/' + tag.slug, key: tag.slug },
	        tag.name
	      );
	    })
	  );
	};
	
	Tags.propTypes = {
	  tags: _propTypes2.default.array,
	  size: _propTypes2.default.string
	};
	
	exports.default = Tags;
	module.exports = exports['default'];

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tags":"src-components-Tags----tags-module---tags---rcuIT","tag":"src-components-Tags----tags-module---tag---2kJvP src-components-Nav----nav-module---tag---2286F src-components-Nav----nav-module---button---7wpvU"};

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var date = new Date();
	  var years = date.getFullYear() - parseInt(props.since, 10);
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    years
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _rehypeReact = __webpack_require__(608);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(43);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Link = __webpack_require__(259);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Feature = __webpack_require__(252);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _HeaderImage = __webpack_require__(255);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _Image = __webpack_require__(256);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _KeyFeatures = __webpack_require__(257);
	
	var _KeyFeatures2 = _interopRequireDefault(_KeyFeatures);
	
	var _Lightbox = __webpack_require__(258);
	
	var _Lightbox2 = _interopRequireDefault(_Lightbox);
	
	var _Quote = __webpack_require__(261);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Tags = __webpack_require__(262);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _Years = __webpack_require__(89);
	
	var _Years2 = _interopRequireDefault(_Years);
	
	var _postModule = __webpack_require__(368);
	
	var _postModule2 = _interopRequireDefault(_postModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$PureComponent) {
	  _inherits(Post, _React$PureComponent);
	
	  function Post(props) {
	    _classCallCheck(this, Post);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.onZoom = _this.onZoom.bind(_this);
	    _this.onZoomOut = _this.onZoomOut.bind(_this);
	
	    _this.state = { lightbox: null };
	    return _this;
	  }
	
	  Post.prototype.onZoom = function onZoom(lightbox) {
	    this.setState({ lightbox: lightbox });
	  };
	
	  Post.prototype.onZoomOut = function onZoomOut() {
	    this.setState({ lightbox: null });
	  };
	
	  Post.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var post = props.data.contentfulPost;
	    var tagString = post.tags ? post.tags.map(function (tag) {
	      return tag.name;
	    }).join(", ") : '';
	    var hasHeaderImage = post.headerImage !== null;
	    var edge2edge = post.edgeToEdgeHeaderImage;
	    var renderAst = new _rehypeReact2.default({
	      createElement: _react2.default.createElement,
	      components: {
	        'block-quote': _Quote2.default,
	        'feature': _Feature2.default,
	        'font-awesome': _reactFontawesome2.default,
	        'custom-image': function customImage(props) {
	          return _react2.default.createElement(_Image2.default, _extends({}, props, { onZoom: _this2.onZoom, images: post.images }));
	        },
	        'key-features': _KeyFeatures2.default,
	        'link': _Link2.default,
	        'years-since': _Years2.default
	      }
	    }).Compiler;
	
	    props.setTheme(post.theme);
	
	    tagString = post.metaKeywords + ", " + tagString;
	
	    var meta = [{ name: 'description', content: post.excerpt.excerpt }, { name: 'keywords', content: tagString }, { name: 'twitter:site', content: '@designbyadrian' }, { name: 'twitter:title', content: post.title }, { name: 'twitter:description', content: post.excerpt.excerpt }, { name: 'twitter:creator', content: '@designbyadrian' }, { name: 'og:site_name', content: 'Design by Adrian' }, { name: 'og:title', content: post.title }, { name: 'og:description', content: post.excerpt.excerpt }, { name: 'og:type', content: 'article' }, { name: 'og:url', content: "http://designbyadrian.com/" + post.slug }, { name: 'og:image', content: post.ogFacebookImage.resize.src }];
	
	    if (post.ogTwitterImage) {
	      meta.push({ name: 'twitter:card', content: post.ogTwitterImage.resize.src });
	    }
	
	    return _react2.default.createElement(
	      "span",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: post.title + " by Design by Adrian",
	        meta: meta
	      }),
	      _react2.default.createElement(_Lightbox2.default, { image: this.state.lightbox, onClose: this.onZoomOut }),
	      _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          transitionName: {
	            appear: _postModule2.default.postAppear,
	            appearActive: _postModule2.default.postAppearActive
	          },
	          transitionAppear: true,
	          transitionAppearTimeout: 300,
	          transitionEnter: false,
	          transitionLeave: false
	        },
	        _react2.default.createElement(
	          "div",
	          { key: post.slug, className: _postModule2.default.post },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/", className: _postModule2.default.homeButton },
	            _react2.default.createElement(
	              "span",
	              { className: "fa-layers fa-fw" },
	              _react2.default.createElement(_reactFontawesome2.default, { icon: "circle", color: "#6e8898" }),
	              _react2.default.createElement(_reactFontawesome2.default, { className: _postModule2.default.homeButtonBg, icon: "circle" }),
	              _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'times'], color: "white", transform: "shrink-2" })
	            )
	          ),
	          post.headerImage && _react2.default.createElement(_HeaderImage2.default, _extends({
	            edge2edge: edge2edge
	          }, post.headerImage)),
	          _react2.default.createElement(
	            "h1",
	            { className: _postModule2.default.postTitle },
	            post.title
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: _postModule2.default.postDate },
	            post.timestamp
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _postModule2.default.contentWrapper },
	            post.tags && _react2.default.createElement(_Tags2.default, { tags: post.tags }),
	            _react2.default.createElement(
	              "div",
	              { className: _postModule2.default.postContent },
	              renderAst(post.childContentfulPostContentTextNode.childMarkdownRemark.htmlAst)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.PureComponent);
	
	;
	
	exports.default = Post;
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-templates----post-module---wrapper---1989e","container-fluid":"src-templates----post-module---container-fluid---1kx_7","row":"src-templates----post-module---row---1EpVI","reverse":"src-templates----post-module---reverse---33ulj","col":"src-templates----post-module---col---3I7_4","col-xs":"src-templates----post-module---col-xs---2P5g_","col-xs-1":"src-templates----post-module---col-xs-1---3CpqZ","col-xs-2":"src-templates----post-module---col-xs-2---cpUh3","col-xs-3":"src-templates----post-module---col-xs-3---17H6q","col-xs-4":"src-templates----post-module---col-xs-4---1Mui8","col-xs-5":"src-templates----post-module---col-xs-5---1SxDi","col-xs-6":"src-templates----post-module---col-xs-6---1ioUE","col-xs-7":"src-templates----post-module---col-xs-7---1Zdlr","col-xs-8":"src-templates----post-module---col-xs-8---2yzo7","col-xs-9":"src-templates----post-module---col-xs-9---3tdOj","col-xs-10":"src-templates----post-module---col-xs-10---EpyjK","col-xs-11":"src-templates----post-module---col-xs-11---21OnM","col-xs-12":"src-templates----post-module---col-xs-12---3mjZg","col-xs-offset-1":"src-templates----post-module---col-xs-offset-1---t3Mxg","col-xs-offset-2":"src-templates----post-module---col-xs-offset-2---2358K","col-xs-offset-3":"src-templates----post-module---col-xs-offset-3---1OUDA","col-xs-offset-4":"src-templates----post-module---col-xs-offset-4---3mdEX","col-xs-offset-5":"src-templates----post-module---col-xs-offset-5---1Ji0q","col-xs-offset-6":"src-templates----post-module---col-xs-offset-6---2PfA7","col-xs-offset-7":"src-templates----post-module---col-xs-offset-7---nVdNx","col-xs-offset-8":"src-templates----post-module---col-xs-offset-8---13yuw","col-xs-offset-9":"src-templates----post-module---col-xs-offset-9---1YndX","col-xs-offset-10":"src-templates----post-module---col-xs-offset-10---1ygsh","col-xs-offset-11":"src-templates----post-module---col-xs-offset-11---3vbS2","col-xs-offset-12":"src-templates----post-module---col-xs-offset-12---33hos","start-xs":"src-templates----post-module---start-xs---cDz1W","center-xs":"src-templates----post-module---center-xs---3bcMg","end-xs":"src-templates----post-module---end-xs---2uL4P","top-xs":"src-templates----post-module---top-xs---256fC","middle-xs":"src-templates----post-module---middle-xs---_Sa_u","bottom-xs":"src-templates----post-module---bottom-xs---356Nn","around-xs":"src-templates----post-module---around-xs---1tYk3","between-xs":"src-templates----post-module---between-xs---EgKDB","first-xs":"src-templates----post-module---first-xs---20Tsl","last-xs":"src-templates----post-module---last-xs---1T1s0","container":"src-templates----post-module---container---2Vqto","col-sm":"src-templates----post-module---col-sm---IR0FJ","col-sm-1":"src-templates----post-module---col-sm-1---2QAIR","col-sm-2":"src-templates----post-module---col-sm-2---ei43p","col-sm-3":"src-templates----post-module---col-sm-3---2XHn6","col-sm-4":"src-templates----post-module---col-sm-4---150yG","col-sm-5":"src-templates----post-module---col-sm-5---39OMf","col-sm-6":"src-templates----post-module---col-sm-6---1ReXL","col-sm-7":"src-templates----post-module---col-sm-7---2JOuZ","col-sm-8":"src-templates----post-module---col-sm-8---2fKM-","col-sm-9":"src-templates----post-module---col-sm-9---Q3IxX","col-sm-10":"src-templates----post-module---col-sm-10---Lb51f","col-sm-11":"src-templates----post-module---col-sm-11---14vHh","col-sm-12":"src-templates----post-module---col-sm-12---1ER9t","col-sm-offset-1":"src-templates----post-module---col-sm-offset-1---2RNqj","col-sm-offset-2":"src-templates----post-module---col-sm-offset-2---2juLe","col-sm-offset-3":"src-templates----post-module---col-sm-offset-3---30sIR","col-sm-offset-4":"src-templates----post-module---col-sm-offset-4---3SttM","col-sm-offset-5":"src-templates----post-module---col-sm-offset-5---T0Hyf","col-sm-offset-6":"src-templates----post-module---col-sm-offset-6---1v_AS","col-sm-offset-7":"src-templates----post-module---col-sm-offset-7---RckCY","col-sm-offset-8":"src-templates----post-module---col-sm-offset-8---1zyi4","col-sm-offset-9":"src-templates----post-module---col-sm-offset-9---200ft","col-sm-offset-10":"src-templates----post-module---col-sm-offset-10---3NgTg","col-sm-offset-11":"src-templates----post-module---col-sm-offset-11---jWKln","col-sm-offset-12":"src-templates----post-module---col-sm-offset-12---FfLnL","start-sm":"src-templates----post-module---start-sm---10xV5","center-sm":"src-templates----post-module---center-sm---1pWJJ","end-sm":"src-templates----post-module---end-sm---ksNGO","top-sm":"src-templates----post-module---top-sm---BW0jK","middle-sm":"src-templates----post-module---middle-sm---1LjbS","bottom-sm":"src-templates----post-module---bottom-sm---3zGY1","around-sm":"src-templates----post-module---around-sm---2c4KT","between-sm":"src-templates----post-module---between-sm---2vTLP","first-sm":"src-templates----post-module---first-sm---3ztsj","last-sm":"src-templates----post-module---last-sm---2VuIV","col-md":"src-templates----post-module---col-md---3p4HU","col-md-1":"src-templates----post-module---col-md-1---2CPma","col-md-2":"src-templates----post-module---col-md-2---3khWj","col-md-3":"src-templates----post-module---col-md-3---2V239","col-md-4":"src-templates----post-module---col-md-4---2cy4z","col-md-5":"src-templates----post-module---col-md-5---23kxL","col-md-6":"src-templates----post-module---col-md-6---33K5X","col-md-7":"src-templates----post-module---col-md-7---1GUVp","col-md-8":"src-templates----post-module---col-md-8---2xGsX","col-md-9":"src-templates----post-module---col-md-9---3DEc-","col-md-10":"src-templates----post-module---col-md-10---2_6pb","col-md-11":"src-templates----post-module---col-md-11---2nQEE","col-md-12":"src-templates----post-module---col-md-12---WmwOU","col-md-offset-1":"src-templates----post-module---col-md-offset-1---3g5LJ","col-md-offset-2":"src-templates----post-module---col-md-offset-2---DpkK4","col-md-offset-3":"src-templates----post-module---col-md-offset-3---1_pt_","col-md-offset-4":"src-templates----post-module---col-md-offset-4---1GLJY","col-md-offset-5":"src-templates----post-module---col-md-offset-5---11D_o","col-md-offset-6":"src-templates----post-module---col-md-offset-6---FRHto","col-md-offset-7":"src-templates----post-module---col-md-offset-7---3OnMH","col-md-offset-8":"src-templates----post-module---col-md-offset-8---zG0QN","col-md-offset-9":"src-templates----post-module---col-md-offset-9---36fXO","col-md-offset-10":"src-templates----post-module---col-md-offset-10---1z9mE","col-md-offset-11":"src-templates----post-module---col-md-offset-11---YfYrQ","col-md-offset-12":"src-templates----post-module---col-md-offset-12---23ITt","start-md":"src-templates----post-module---start-md---1iDsH","center-md":"src-templates----post-module---center-md---36Y3X","end-md":"src-templates----post-module---end-md---yiT98","top-md":"src-templates----post-module---top-md---3RLae","middle-md":"src-templates----post-module---middle-md---1U3e1","bottom-md":"src-templates----post-module---bottom-md---2MImJ","around-md":"src-templates----post-module---around-md---3yqYh","between-md":"src-templates----post-module---between-md---1bI9W","first-md":"src-templates----post-module---first-md---3fifb","last-md":"src-templates----post-module---last-md---2KI4s","col-lg":"src-templates----post-module---col-lg---3LDoP","col-lg-1":"src-templates----post-module---col-lg-1---Qxte8","col-lg-2":"src-templates----post-module---col-lg-2---AoYUx","col-lg-3":"src-templates----post-module---col-lg-3---32rcA","col-lg-4":"src-templates----post-module---col-lg-4---1ZDYN","col-lg-5":"src-templates----post-module---col-lg-5---7XmM3","col-lg-6":"src-templates----post-module---col-lg-6---3j0iZ","col-lg-7":"src-templates----post-module---col-lg-7---3WoZo","col-lg-8":"src-templates----post-module---col-lg-8---2TvWp","col-lg-9":"src-templates----post-module---col-lg-9---gtwxM","col-lg-10":"src-templates----post-module---col-lg-10---2-nH_","col-lg-11":"src-templates----post-module---col-lg-11---1ArJ0","col-lg-12":"src-templates----post-module---col-lg-12---VsjIP","col-lg-offset-1":"src-templates----post-module---col-lg-offset-1---3ewQt","col-lg-offset-2":"src-templates----post-module---col-lg-offset-2---2s9EA","col-lg-offset-3":"src-templates----post-module---col-lg-offset-3---1bGKi","col-lg-offset-4":"src-templates----post-module---col-lg-offset-4---2AHGK","col-lg-offset-5":"src-templates----post-module---col-lg-offset-5---rNhz7","col-lg-offset-6":"src-templates----post-module---col-lg-offset-6---25l0y","col-lg-offset-7":"src-templates----post-module---col-lg-offset-7---1NwyG","col-lg-offset-8":"src-templates----post-module---col-lg-offset-8---1caXi","col-lg-offset-9":"src-templates----post-module---col-lg-offset-9---tvNLW","col-lg-offset-10":"src-templates----post-module---col-lg-offset-10---zUcUI","col-lg-offset-11":"src-templates----post-module---col-lg-offset-11---5bK8d","col-lg-offset-12":"src-templates----post-module---col-lg-offset-12---OHQTY","start-lg":"src-templates----post-module---start-lg---3B1XH","center-lg":"src-templates----post-module---center-lg---zPIKU","end-lg":"src-templates----post-module---end-lg---svlFV","top-lg":"src-templates----post-module---top-lg---S4tgv","middle-lg":"src-templates----post-module---middle-lg---2_Fih","bottom-lg":"src-templates----post-module---bottom-lg---3wggT","around-lg":"src-templates----post-module---around-lg---279-k","between-lg":"src-templates----post-module---between-lg---MIag5","first-lg":"src-templates----post-module---first-lg---Z7D1j","last-lg":"src-templates----post-module---last-lg---2UZsw","homeButton":"src-templates----post-module---homeButton---1WwQs","homeButtonBg":"src-templates----post-module---homeButtonBg---3upXl","post":"src-templates----post-module---post---1QEqX","postAppear":"src-templates----post-module---postAppear---2ozkv","postAppearActive":"src-templates----post-module---postAppearActive---3gREr","postDate":"src-templates----post-module---postDate---2xCyX","postTitle":"src-templates----post-module---postTitle---1J-sd","contentWrapper":"src-templates----post-module---contentWrapper---pqPo3","postContent":"src-templates----post-module---postContent---2VGsn","link":"src-templates----post-module---link---3Qgnl"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-js-d7290af7609faaffd04b.js